import { SUCCESS_SHOW, SUCCESS_DISMISS } from "./actionTypes";

export function showSubmitSuccess() {
  return { type: SUCCESS_SHOW };
}

export function hideSubmitSuccess() {
  return { type: SUCCESS_DISMISS };
}
